import { Autocomplete, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip,} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller, useForm } from "react-hook-form";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { BtnLoader } from "../../components/common/Loader";
import { useState } from "react";
import dayjs from "dayjs";
import { CiExport } from "react-icons/ci";
import { createEntity } from "../../apis/apiService";
import { toast } from "react-toastify";
import { useFetchUserAccessedProjectsQuery } from "../../slice/logdetailSlice";
import { useTheme } from "../../ThemeContext";

const CommonImportProject = ({ isProjectModule, project_id, haveText }) => {
  const { isDarkMode } = useTheme();
  const [exportDate, setExportDate] = useState({
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
  });
  const { data: projectNames = [] } = useFetchUserAccessedProjectsQuery();
  // console.log("project_details :", isProjectModule);

  const [filterLoading, setFilterLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projecttitle: isProjectModule ? [] : [project_id],
      StartDate: null,
    },
  });
  const exportToExcel = async (formData) => {
    try {
      setFilterLoading(true);

      const startOfMonth = formData.StartDate
        ? dayjs(formData.StartDate).startOf("month").format("YYYY-MM-DD")
        : null;

      const endOfMonth = formData.StartDate
        ? dayjs(formData.StartDate).endOf("month").format("YYYY-MM-DD")
        : null;
      setExportDate({
        start_date: startOfMonth ? startOfMonth : exportDate.start_date,
        end_date: endOfMonth ? endOfMonth : exportDate.end_date,
      });
      //   setUserId(formData.Users);
      const requestedData = {
        projectIds: isProjectModule ? formData.projecttitle : [project_id],
        fromDate: startOfMonth,
        toDate: endOfMonth,
        isExport:true
      };

      // console.log("requestedData:", requestedData);

      const response = await createEntity(
        "exportProjectHoursLog",
        requestedData
      );

      if (response) {
        setFilteredData(response.data); // Update filtered logs
        setFilterOpen(false); // Close filter popup
        toast.success(response.message);

        const link = document.createElement("a");
        link.href = response.url; // Ensure this is a direct file download URL
        link.setAttribute("download", ""); // Let the backend decide the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // setShowFilter(true);
      }
    } catch (error) {
      // console.error("Filter error:", error);
      toast.error(error.message);
    } finally {
      setFilterLoading(false);
    }
  };
  return (
    <div>
      <Tooltip title={haveText ? "" : "Export"}>
        {haveText ? (
          <button
            onClick={() => setFilterOpen(true)}
            className="border-0 bg-transparent text-decoration-none me-3 p-2 d-flex align-items-center"
            style={{ cursor: "pointer", width: "100%" }}
          >
            <CiExport 
              className="text-rgbr-blue pro-icon-s" 
              style={{ color: "rgba(18, 183, 159, 1)", fontSize: "24px" }} 
            />
            <span 
              className={isDarkMode ? "text-white mx-2 mt-2" : "text-dark mx-2 mt-2"}
              style={{ fontSize: "14px", fontWeight: 400, whiteSpace: "nowrap" }}
            >
              Export Project
            </span>
          </button>
        ) : (
          <IconButton
            onClick={() => setFilterOpen(true)}
            sx={{
              backgroundColor: isDarkMode
                ? "rgba(67, 105, 255, 0.08)"
                : "#F1F5FF",
              borderRadius: "50%",
              width: "39px",
              height: "39px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor: "var(--icon-hover-bg)",
              },
            // mr: 0,
            }}
          >
          {/* <CiExport className="pro-icon-s" style={{ color: "rgba(18, 183, 159, 1)" }} />
          {haveText && (
            <span
              style={{ fontSize: "14px", marginLeft: "8px", color: isDarkMode ? "white" : "black" }}
          >
              Export project
            </span>
          )}
        </IconButton> */}
            <CiExport
              className="pro-icon-s"
              style={{ color: "rgba(18, 183, 159, 1)", fontSize: "22px" }}
            />
          </IconButton>
        )}
      </Tooltip>
      
        {/* <span className=" mt-2 mx-2">Export</span> */}
      {/* </button> */}

      <div>
        <Dialog
          open={filterOpen}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "60vh",
              width: "90%",
              maxWidth: "500px",
              borderRadius: "12px",
            },
          }}
          onClose={() => {}}
          disableEscapeKeyDown
        >
          <DialogTitle>
            Export Projects
            <IconButton
              onClick={() => setFilterOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 1,
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <form onSubmit={handleSubmit(exportToExcel)}>
                {isProjectModule && (
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <label htmlFor="Users" className="form-label">
                        Projects <span className=" errorMsg">*</span>
                      </label>

                      <Controller
                        name="projecttitle"
                        control={control}
                        rules={{ required: "Project name is required" }}
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            multiple
                            id="projecttitle"
                            options={projectNames || []}
                            disableCloseOnSelect
                            
                            getOptionLabel={(option) => option.title}
                            value={
                              (value || [])
                                .map((project_id) =>
                                  projectNames?.find(
                                    (project) =>
                                      project.project_id === project_id
                                  )
                                )
                                .filter(Boolean) // Ensure valid objects
                            }
                            onChange={(event, newValue) => {
                              const selectedIds = newValue.map(
                                (project) => project.project_id
                              );
                              onChange(selectedIds); // ✅ only pass IDs
                            }}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <strong>{option.title}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={
                                  value && value.length > 0
                                    ? ""
                                    : "Enter project name"
                                }     
                              />
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.projecttitle && (
                        <span className="errorMsg">
                          {errors.projecttitle.message}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <Box my={2} width="100%" display="flex" flexDirection="column">
                  <label htmlFor="StartDate">
                    Month <span className=" errorMsg">*</span>
                  </label>
                  <Controller
                    name="StartDate"
                    control={control}
                    rules={{ required: "Month field is required" }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        views={["year", "month"]}
                        // format="YYYY MM"
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="Month"
                            sx={{
                              width: "100%",
                              display: "block",
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  {errors?.StartDate && (
                    <span className="errorMsg">{errors.StartDate.message}</span>
                  )}
                </Box>

                <DialogActions>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={() => {
                      setFilterOpen(false);
                      reset();
                    }}
                    disabled={filterLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="add_btn"
                    disabled={filterLoading}
                  >
                    {filterLoading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Export"
                    )}
                  </button>
                </DialogActions>
              </form>
            </LocalizationProvider>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};
export default CommonImportProject;
